<template>
  <ExpedienteCreateApelacionView title="Nuevo descargo" prefix-create-path="case_file/discharge/"></ExpedienteCreateApelacionView>
</template>

<script>
import ExpedienteCreateApelacionView from './ExpedienteCreateApelacionView'

export default {
  components: {
    ExpedienteCreateApelacionView
  }
}
</script>
